import script from "./UserProfileTile.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfileTile.vue?vue&type=script&setup=true&lang=js"

export default script